import daterangepicker from 'daterangepicker';
import select2 from 'select2';

$.urlParam = function(name){
  var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
  if (results==null) {
     return null;
  }
  return decodeURI(results[1]) || 0;
}

$(document).ready(function() {  
  $('.mob-show-filter').click(function(event) {
  	$('.sidebar').fadeToggle();
  	event.preventDefault();
  });

  if ($(window).width() < 768) {
    $(document).click(function(e) {
        if (!$(e.target).is('.sidebar, .sidebar *, .mob-show-filter, .mob-show-filter *')) {
    			$('.sidebar').fadeOut();
        }
    });
  }
  
  $(".js-select-2").select2({minimumResultsForSearch: -1}).on("change", function () {  
    var url = window.location.href.split('?')[0];
    document.location.href = url + '?country=' + $("#country").val() + "&tags=" + $("#tags").val();
  });
  
});